exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-scrollbar::-webkit-scrollbar{width:0;height:0}.app-footer{width:100%;height:.98rem;position:fixed;bottom:0}.has-footer{padding-bottom:.98rem}#sc * .ali-ele *{-webkit-box-sizing:content-box;box-sizing:content-box}#sc .sm-btn,.ali-ele .sm-btn{border:1px solid #f7f7f7;background:#f7f7f7}.coupon-btn-title{text-align:center;margin:10px 0}.coupon-btn-title span{display:inline-block;height:35px;line-height:35px;width:140px;font-size:14px;color:#fff;background:#169bd4;border-radius:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-574d636e","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = cPn6
// module chunks = 29